'use client';
import { useEventListener as o } from "./use-event-listener.js";
function d(t, i, s = "mousedown", u = {}) {
  o(
    s,
    (r) => {
      const n = r.target;
      if (!n || !n.isConnected)
        return;
      (Array.isArray(t) ? t.filter((e) => !!e.current).every((e) => e.current && !e.current.contains(n)) : t.current && !t.current.contains(n)) && i(r);
    },
    void 0,
    u
  );
}
export {
  d as useOnClickOutside
};
